import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';
import { UploadFileModel } from '@portal/upload-file/data-access';
import { MatIconModule } from '@angular/material/icon';
import { PreviewFileDirective } from '@portal/preview-file/data-access';

@Component({
  selector: 'portal-form-preview-file',
  standalone: true,
  imports: [MatIconModule, PreviewFileDirective, NgClass, NgIf],
  template: `
    <div
      #previewFile="portalPreviewFile"
      (click)="previewFile.previewFile()"
      [file]="fileModel.file"
      [keyName]="fileModel.key"
      [ngClass]="{ 'field-file-value': true, 'field-file-value-error': fileModel.error }"
      portalPreviewFile
    >
      <span class="flex items-center justify-center">
        <mat-icon
          class="field-file-prefix icon-size-5"
          svgIcon="attach_file"
        ></mat-icon>
      </span>
      <span class="break-all text-balance">{{ fileModel.fileName }}</span>
      <button
        (click)="$event.stopPropagation(); remove.emit(fileModel)"
        *ngIf="!isDisabled"
        class="flex items-center justify-center"
        type="button"
      >
        <mat-icon
          class="text-primary icon-size-5"
          svgIcon="recycle_bin"
        ></mat-icon>
      </button>
    </div>
  `,
  styles: [':host{display: block}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewFileComponent {
  @Input() fileModel!: UploadFileModel;
  @Input() isDisabled = false;
  @Output() remove = new EventEmitter<UploadFileModel>();
}
